/** Items de navegación del área autenticada (/app) — sidebar desktop */
export const sidebarNavItems = [
  { path: '/app', icon: 'Home', label: 'Inicio (Clips)' },
  { path: '/app/entrenamientos', icon: 'PlayCircle', label: 'Entrenamientos' },
  { path: '/app/recursos', icon: 'FileText', label: 'Recursos' },
  { path: '/app/comunidad', icon: 'Users', label: 'Comunidad' },
  { path: '/app/herramientas/calendario', icon: 'Calendar', label: 'Sesiones en Vivo' },
];

/** Items de navegación móvil — bottom nav */
export const bottomNavItems = [
  { path: '/app', icon: 'Home', label: 'Inicio' },
  { path: '/app/entrenamientos', icon: 'PlayCircle', label: 'Aprender' },
  { path: '/app/recursos', icon: 'FileText', label: 'Recursos' },
  { icon: 'Menu', label: 'Menú', isMenu: true },
];

/**
 * Destinos del menú móvil (overflow) — rutas y acciones no presentes en la bottom bar.
 * Añadir entradas aquí para exponerlas en el sheet sin tocar BottomNav.
 */
export const mobileMenuNavItems = [
  { path: '/app/comunidad', icon: 'Users', label: 'Comunidad' },
  { path: '/app/herramientas/calendario', icon: 'Calendar', label: 'Sesiones en Vivo' },
];

/** Admin — mismas rutas que el sidebar; visibilidad según permisos en el componente. */
export const mobileMenuAdminNavItems = [
  { path: '/app/admin/usuarios', icon: 'Shield', label: 'Admin Usuarios', permission: 'view_agent_conflicts' },
  { path: '/app/admin/og-defaults', icon: 'Share2', label: 'Vista Previa OG', permission: 'manage_users' },
];

/** Rutas que activan el tab «Menú» en la bottom bar. */
export function getMobileMenuActivePaths(can) {
  const paths = mobileMenuNavItems.map((item) => item.path);
  mobileMenuAdminNavItems.forEach((item) => {
    if (can(item.permission)) paths.push(item.path);
  });
  return paths;
}

export function isMobileMenuRouteActive(pathname, can) {
  return getMobileMenuActivePaths(can).some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );
}
